var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role box"},[_c('div',{staticClass:"box-left"},[_c('div',{staticClass:"left-top"},[_c('span',{staticClass:"f-w-b"},[_vm._v("404")]),_c('div',[_vm._v("需要访问的页面不存在！")])])])])
}]

export { render, staticRenderFns }